var $63cf4a75ec270508$exports = {};
$63cf4a75ec270508$exports = {
  "Clear search": "Wyczy\u015B\u0107 zawarto\u015B\u0107 wyszukiwania"
};
export { $63cf4a75ec270508$exports as default };